<template>
    <div>
        <breadcrumb :routerList="[{'title':'流程管理','to':'/process/BscProProdef'},{title:'流程定义'}]"/>
        <div class="h-content">
            <div class="h-row" style="background: #fff;margin-top: 0px;padding-top: 20px;">
                <div class="h-rowIn" >
                    <div class="h-formLine">
                        <el-form ref="form" :model="form"
                                 :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
                            <el-form-item label="流程名称" prop="name" :rules="[
								  { required: true, message: '请输入流程名称名称', trigger: 'blur'},
								]" class="h-elformWrap-2">
                                <el-input v-model="form.name"></el-input>
                            </el-form-item>
                            <el-form-item label="流程定义的key" prop="defkey" :rules="[
								  { required: true, message: '请输入流程定义的key名称', trigger: 'blur'},
								]" class="h-elformWrap-2">
                                <el-input v-model="form.defkey"></el-input>
                            </el-form-item>
                            <el-form-item label="版本号" prop="version" :rules="[
								  { required: true, message: '请输入排序号名称', trigger: 'blur'},
								  { type: 'number', message: '排序号必须为数字值', trigger: 'blur'}
								]" class="h-elformWrap-2">
                                <el-input  v-model.number="form.version"></el-input>
                            </el-form-item>
                            <el-form-item label="描述" prop="des" :rules="[
								  { required: true, message: '请输入描述名称', trigger: 'blur'},
								]" class="h-elformWrap-2">
                                <el-input v-model="form.des"></el-input>
                            </el-form-item>
                            <el-form-item label="流程分类" prop="progresstype" :rules="[
								  { required: true, message: '流程分类不能为空', trigger: 'blur'},
								]" class="h-elformWrap-2">
                                <brselect clearable category="progress_type" :v="form.progresstype"
                                          v-model="form.progresstype"></brselect>
                            </el-form-item>
                            <el-form-item label="可用标志" prop="delflag" :rules="[
								  { required: true, message: '请输入可用标志名称', trigger: 'blur'},
								]" class="h-elformWrap-2">
                                <brselect clearable category="shifou_keyong" :v="form.delflag"
                                          v-model="form.delflag"></brselect>
                            </el-form-item>

                        </el-form>
                    </div>
                </div>
                <div class="h-rowIn" style="width: 5%;">
                    <section style="text-align: center">
                        <h3 style="border-bottom: 1px solid rgb(204, 204, 204);
                                        font-size: 13px;
                                        line-height: 32px;
                                        height: 32px;">元素</h3>
                        <ul class="elements">
                            <li class="element"
                                v-for="(element,idx) in elements"
                                :key="idx">
                                <img v-bind="element"
                                     class="element-img"
                                     :shape="element.shape"
                                     :width="element.w"
                                     :height="element.h"
                                     :src="element.icon"
                                     :alt="element.title">
                                <p>{{ element.title }}</p>
                            </li>
                        </ul>
                    </section>
                </div>
                <div class="h-rowIn" style="width: 95%;position: relative">
                    <div class="tool-bar" style="margin: 2px 0;">
                        <el-button
                                @click="saveProdef"
                                type="primary"
                                size="mini">
                            保存
                        </el-button>
                        <el-button
                                type="primary"
                                size="mini"
                                @click="del"
                                :disabled="_.isEmpty(selectVertex) && _.isEmpty(selectEdge)">
                            删除
                        </el-button>
                        <el-button
                            @click="plus"
                            type="success"
                            size="mini">
                            放大
                        </el-button>
                        <el-button
                            type="success"
                            size="mini"
                            @click="minus" >

                            缩小
                        </el-button>
                    </div>
                    <div id="graphContainer">

                    </div>
                    <div ref="dialogVertex" v-show="dialogVertexVisible" class="el-panel nodelinecls">
                        <el-form ref="nodedata" :model="nodedata" class="demo-ruleForm h-dialogForm">
                            <el-form-item  label="流程定义id" :label-width="formLabelWidth">
                                <el-input v-model="nodedata.defid" readonly type="text" placeholder="请输入内容"/>
                            </el-form-item>
                            <el-form-item  label="节点id" :label-width="formLabelWidth">
                                <el-input v-model="nodedata.id" readonly type="text" placeholder="请输入内容"/>
                            </el-form-item>
                            <el-form-item label="节点类型" v-if="isnodeFlag" :label-width="formLabelWidth">
                                <el-input v-model="nodedata.type" readonly type="text" placeholder="请输入内容"/>
                            </el-form-item>
                            <el-form-item label="是否并联审批" v-if="isnodeFlag" :label-width="formLabelWidth">
                                <el-radio-group v-model="nodedata.binglianflag">
                                    <el-radio :label="1">并行审批</el-radio>
                                    <el-radio :label="2">排它审批</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="节点编码" :label-width="formLabelWidth">
                                <el-input v-model="nodedata.code" type="text" placeholder="请输入内容"/>
                            </el-form-item>
                            <el-form-item label="节点名称" :label-width="formLabelWidth">
                                <el-input v-model="nodedata.name" readonly type="text" placeholder="请输入内容"/>
                            </el-form-item>
                            <el-form-item label="待办人" v-if="isnodeFlag" :label-width="formLabelWidth">
                                <el-input v-model="nodedata.userevl"  type="text">
                                    <el-button slot="append" @click="selectUser" icon="el-icon-search"></el-button>
                                </el-input>
                                <ul class="el-upload-list el-upload-list--text">
                                    <li v-for="o,i in userlist" :tabindex="i" :key="o.id" class="el-upload-list__item is-success">
                                        <i class="el-icon-user">{{o.username}},工号：{{o.usercode}}</i>
                                        <i @click="removeUser(o)"  class="el-icon-close"></i>
                                    </li>
                                </ul>
                            </el-form-item>
                            <el-form-item label="web代办url" v-if="isnodeFlag" :label-width="formLabelWidth">
                                <el-input v-model="nodedata.dburl" type="text" placeholder="请输入内容"/>
                            </el-form-item>
                            <el-form-item label="app代办url" v-if="isnodeFlag" :label-width="formLabelWidth">
                                <el-input v-model="nodedata.appdburl" type="text" placeholder="请输入内容"/>
                            </el-form-item>
                            <el-form-item label="执行条件" v-if="!isnodeFlag"  :label-width="formLabelWidth">
                                <el-input v-model="nodedata.evl" type="text" placeholder="请输入内容"/>
                            </el-form-item>
                            <el-form-item label="节点描述" :label-width="formLabelWidth">
                                <el-input v-model="nodedata.des" type="textarea" placeholder="请输入内容"/>
                            </el-form-item>
                            <el-form-item label="是否发送邮件" v-if="isnodeFlag" :label-width="formLabelWidth">
                                <el-radio-group v-model="nodedata.sendemailflag">
                                    <el-radio :label="1">发送</el-radio>
                                    <el-radio :label="0">不发送</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="邮件内容" :label-width="formLabelWidth">
                                <el-input v-model="nodedata.emailcontent" type="textarea" placeholder="请输入内容"/>
                            </el-form-item>
                            <el-form-item label="是否iHaier待办" v-if="isnodeFlag" :label-width="formLabelWidth">
                                <el-radio-group v-model="nodedata.tohaierflag">
                                    <el-radio :label="1">发送</el-radio>
                                    <el-radio :label="0">不发送</el-radio>
                                </el-radio-group>
                            </el-form-item>

                            <el-form-item style="text-align: center">
								<el-button class="h-btn h-bBtn h-bgwhite" @click="dialogVertexVisible = false">返回</el-button>
                                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submitNodeLine">提交</el-button>
                            </el-form-item>
                        </el-form>np
                    </div>
                </div>
            </div>
            <alluser :visible.sync="uservisible" @choseUser="choseUser" title="选择用户"/>
        </div>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    import _ from 'loadsh'
    import mxgraph from './graph/index';
    import {genGraph, destroyGraph, Graph} from './graph/Graph';
    import { elements } from './graph/prodefdata';
    import alluser from '../../components/dialog/alluser'
    const {
        mxEvent,
        mxCell,
        mxGeometry,
        mxUtils,
        mxEventObject,
    } = mxgraph;

    Object.assign(mxEvent, {
        NORMAL_TYPE_CLICKED: 'NORMAL_TYPE_CLICKED',
    });

    let graph = null;
    const insertVertex = (dom, target, x, y) => {
        const flag = dom.getAttribute('flag');
        let title = "";
        if(flag!=40 && flag!=50){
            title = dom.getAttribute('alt');
        }
        const style = dom.getAttribute('shape');
        const kuan=dom.getAttribute("kuan")||120;
        const gao=dom.getAttribute("gao")||60;
        const nodeRootVertex = new mxCell(title, new mxGeometry(0, 0, kuan, gao), style+";node");
        nodeRootVertex.vertex = true;
        // 自定义的业务数据放在 data 属性
        nodeRootVertex.flag = flag
        const cells = graph.importCells([nodeRootVertex], x, y, target);
        if (cells != null && cells.length > 0) {
            graph.setSelectionCells(cells);
        }
    };

    const makeDraggable = (sourceEles) => {
        const dropValidate = function (evt) {
            const x = mxEvent.getClientX(evt);
            const y = mxEvent.getClientY(evt);
            // 获取 x,y 所在的元素
            const elt = document.elementFromPoint(x, y);
            // 如果鼠标落在graph容器
            if (mxUtils.isAncestorNode(graph.container, elt)) {
                return graph;
            }
            // 鼠标落在其他地方
            return null;
        };

        // drop成功后新建一个节点
        const dropSuccessCb = function (_graph, evt, target, x, y) {
            console.log('dropSuccessCb',this)
            insertVertex(this.element, target, x, y);
        };

        Array.from(sourceEles).forEach((ele) => {
            const dragElt = document.createElement('img');
            dragElt.setAttribute('src', ele.getAttribute('src'));
            dragElt.setAttribute('style', 'width:90px;');
            mxUtils.makeDraggable(ele, dropValidate, dropSuccessCb, dragElt,
                null, null, null, true);
        });
    };

    const listenGraphEvent = () => {
        graph.addListener(mxEvent.CLICK, (sender, evt) => {
            const cell = evt.properties.cell;
            if (!cell) {
                return;
            }
            // 使用 mxGraph 事件中心，触发自定义事件
            graph.fireEvent(new mxEventObject(mxEvent.NORMAL_TYPE_CLICKED, 'cell', cell))

        });
    };



    const initGraph = (ts) => {
        graph = genGraph(document.getElementById('graphContainer'));
        // 将外元素拖拽进画布参考这个例子
        // https://github.com/jinzhanye/mxgraph-demos/blob/master/src/07.drag.html
        makeDraggable(document.getElementsByClassName('element-img'));
        listenGraphEvent();
        //初始化，加载流程定义数据
        ts.init();
    };


    export default {
        components:{alluser},
        name: 'AppCanvas',
        data() {
            return {
                uservisible:false,
                id: null,
                optflag: null,
                prodef: null,
                dialogVertexVisible: false,
                elements,
                userlist:[],
                selectEdge: {},
                selectVertex: {},
                nodedata:{
                    id:'',
                    defid:null,
                    type:null,
                    code:null,
                    name:null,
                    userevl:null,
                    binglianflag:1,
                    dburl:null,
                    appdburl:null,
                    evl:null,
                    des:null,
                    userflag:'',
                    sendemailflag:0,
                    tohaierflag:0,
                    emailcontent:''
                },
                formLabelWidth: '110px',
                isnodeFlag:true,
                form:{
                    id:'',
                    defkey:'',
                    name:'',
                    version:null,
                    des:'',
                    delflag:null,
                    prodefxml:null,
                    progresstype:null,
                },
                formversion:null,
            };
        },
        computed: {


        },

        methods: {
            selectUser(){
                this.uservisible = true;
            },
            choseUser(users){
                this.userlist = _.unionBy(this.userlist,users,"usercode");
            },
            removeUser(u){
                this.userlist = _.reject(this.userlist,{usercode:u.usercode})
            },
            submitNodeLine(){
                //更新节点
                if(this.isnodeFlag){
                    this.nodedata.users=this.userlist
                    ss.prodefservice.updateNode(this.nodedata).then(rd=>{
                        this.$msg.msgs("提交成功！")
                    })
                }else{
                    //更新连线
                    ss.prodefservice.updateLine(this.nodedata).then(rd=>{
                        this.$msg.msgs("提交成功！")
                    })
                }
            },
            init() {
                if(this.id){
                    ss.prodefservice.selectById(this.id).then(rd => {
                        this.form = rd.obj;
                        this.formversion=this.form.version;
                        this.prodef = rd.obj;
                        graph.importModelXML(this.prodef.prodefxml);
                    })
                }
            },
            //*******
            // File
            //*******
            // 导出、导入功能参考这个例子
            saveProdef() {
                this.form.prodefxml = graph.exportModelXML();
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        ss.prodefservice.insertOrUpdate(this.form).then(rd=>{
                            this.id=rd.obj.id;
                            this.form.id = rd.obj.id;
                            this.$msg.msgs("保存成功！")
                        });
                    }
                });
            },
            del() {
                console.log(this.selectVertex)
                console.log(this.selectEdge)
                if (!_.isEmpty(this.selectVertex)) {
                    graph.removeCells([this.selectVertex]);
                } else {
                    graph.removeCells([this.selectEdge]);
                }
            },
            plus(){
                graph.zoomIn();

            },

            minus(){
                graph.zoomOut();
            },
            //选中元素的时候
            showNormalTypeSelect(sender, evt) {

            },

            //选中的元素改变的时候
            handleSelectionChange(selectModel) {
                this.selectVertex = {};
                this.selectEdge = {};
                if (!selectModel.cells.length) {
                    return;
                }
                const cell = selectModel.cells[0];
                // 另一种获取当前节点的方法
                if (cell.vertex) {
                    this.selectVertex = cell;
                } else {
                    this.selectEdge = cell;
                }
            },
            _listenEvent() {
                const vm = this;
                // 监听自定义事件
                graph.addListener(mxEvent.NORMAL_TYPE_CLICKED, this.showNormalTypeSelect);

                // 监听 mxGraph 事件
                const mxGraphSelectionModel = graph.getSelectionModel();
                mxGraphSelectionModel.addListener(mxEvent.CHANGE, this.handleSelectionChange);
//捕获任务节点的鼠标点击事件
                graph.addListener(mxEvent.DOUBLE_CLICK, function(sender, evt) {
                    var cell = evt.getProperty('cell');
                    if(!cell){
                        vm.dialogVertexVisible = false;
                        return;
                    }

                    console.log(1234)
                    if(!vm.id){
                        return;
                    }
                    vm.dialogVertexVisible = true;
                    vm.nodedata.id = cell.id
                    vm.nodedata.defid = this.id
                    vm.nodedata.type = cell.flag
                    vm.nodedata.name = cell.value

                    vm.isnodeFlag = !cell.edge;
                    var params = {id:cell.id};
                    if(vm.isnodeFlag){
                        params.flag="node"
                    }
                    if(cell.flag==10 || cell.flag == 100 || cell.flag == 40 || cell.flag == 50){
                        vm.dialogVertexVisible = false;
                        return;
                    }
                    ss.prodefservice.selectNodeLineById(params).then(rd=>{
                        console.log("返回节点：",rd)
                        vm.nodedata = rd.obj;
                        vm.userlist = rd.obj.users;
                    });
                });
                //节点移动事件
                graph.addListener(mxEvent.MOVE_CELLS, (sender, evt) => {
                    const cell = evt.properties.cells[0];
                    const position = Graph.getCellPosition(cell);

                });


                //添加节点或者线
                graph.addListener(mxEvent.CELLS_ADDED, (sender, evt) => {
                    const cell = evt.properties.cells[0];
                    cell.setId(this.$util.getUuid());
                    if (graph.isPart(cell)) {
                        return;
                    }
                    if (cell.vertex) {
                        this.$msg.msgs('添加了一个节点');
                    } else if (cell.edge) {
                        cell.setValue("通过")
                        this.$msg.msgs('添加了一条线');
                    }
                });

                //修改内容
                graph.addListener(mxEvent.LABEL_CHANGED, (sender, evt) => {

                    console.log("修改内容",evt)
                    const cell = evt.properties;
                    console.log("修改内容，cell",cell)
                    console.log("修改内容，cell",cell.value)
                    vm.nodedata.name = cell.value
                });

                //改变连线
                graph.addListener(mxEvent.CONNECT_CELL, (sender, evt) => {
                    console.log("改变连线",evt)
                    const cell = evt.properties[0].cell;
                });
            },






        },

        mounted() {
            this.id = this.$route.query.id;
            this.optflag = this.$route.query.optflag;

            initGraph(this);
            this._listenEvent();
        },

        beforeDestroy() {
            destroyGraph();
        }
    }
</script>

<style  scoped>
    #graphContainer {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 850px;
        background: url('../../assets/images/flow/grid.gif');;
        border-radius: 4px;
    }
    .elements .element-img{
        margin-top: 20px;
    }
    .elements p{
        font-size: 12px;
    }
    .nodelinecls{
        border:1px solid #ccc;
        width: 400px;
        position: absolute;
        top: 0px;
        right: 10px;
        background: #d5f1e0;
        z-index: 99999;
    }
    .nodelinecls .el-form-item {
        margin-bottom: 5px;
    }
    .h-dialogForm{
        padding:10px 0!important;
    }

</style>
